import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Phone, MessageCircle, ArrowLeft, Leaf } from "lucide-react";
import { BUSINESS } from "@/data/site";

const waLink = `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(BUSINESS.whatsappMessage)}`;

export default function RequestReceived() {
  return (
    <div
      data-testid="request-received-page"
      className="relative flex min-h-screen flex-col items-center justify-center bg-[var(--bg)] px-6 py-16"
    >
      <Link
        to="/"
        data-testid="back-home-link"
        className="absolute left-6 top-6 flex items-center gap-2 text-sm font-medium text-[var(--ink-soft)] transition-colors hover:text-[var(--green)] md:left-10 md:top-10"
      >
        <ArrowLeft size={16} /> Back to home
      </Link>

      <div className="absolute right-6 top-6 flex items-center gap-2.5 md:right-10 md:top-10">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--green)] text-white">
          <Leaf size={18} />
        </span>
        <span className="font-display text-lg font-bold tracking-tight text-[var(--ink)]">M N Savanur</span>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative flex max-w-xl flex-col items-center text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 180 }}
          className="relative mb-8"
        >
          <span className="absolute inset-0 animate-ping rounded-full bg-[var(--green)]/20" />
          <span className="relative flex h-24 w-24 items-center justify-center rounded-full bg-[var(--green)] text-white shadow-xl shadow-green-900/20">
            <CheckCircle2 size={48} strokeWidth={2.2} />
          </span>
        </motion.div>

        <span className="overline text-[var(--green)]">Enquiry Received</span>
        <h1 className="mt-4 font-display text-4xl font-bold leading-tight tracking-tight text-[var(--ink)] sm:text-5xl">
          Thank you!
        </h1>
        <p className="mt-5 max-w-md text-base leading-relaxed text-[var(--ink-soft)] md:text-lg">
          Your wholesale enquiry has been received. Our team will contact you shortly
          with competitive bulk pricing and delivery details.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <a
            href={`tel:${BUSINESS.phone}`}
            data-testid="rr-call-now"
            className="group flex items-center gap-2 rounded-full bg-[var(--green)] px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-[var(--green-deep)] hover:shadow-lg hover:shadow-green-900/20"
          >
            <Phone size={16} /> Call Now
          </a>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="rr-whatsapp"
            className="flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-all hover:brightness-95"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
          <Link
            to="/"
            data-testid="rr-home-btn"
            className="flex items-center gap-2 rounded-full border border-[var(--border)] bg-white px-6 py-3 text-sm font-semibold text-[var(--ink)] transition-all hover:border-[var(--green)]/50"
          >
            Back to Home
          </Link>
        </div>

        <p className="mt-10 border-t border-[var(--border)] pt-6 text-xs text-[var(--ink-soft)]">
          Prefer to talk now? Call us directly at{" "}
          <a href={`tel:${BUSINESS.phone}`} className="font-semibold text-[var(--green)]">
            {BUSINESS.phone}
          </a>
          .
        </p>
      </motion.div>
    </div>
  );
}
